// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ding-table[data-v-538b0da0]{table-layout:auto}.ding-table th[data-v-538b0da0]{white-space:nowrap}.dark-background[data-v-538b0da0]{background-color:#f6f6f6}.paging-information[data-v-538b0da0]{font-size:12px;margin:16px 0;color:#90a4ae}.min-100[data-v-538b0da0]{min-width:100px}", ""]);
// Exports
module.exports = exports;
